import { Button } from "primereact/button"
import { EnergyRating } from "../../../components/EnergyRating"
import { useTranslation } from "react-i18next"

const ProductDataQualityScore = ({control,avgReliability,avgIntegrity,dqr,isEditable}) => {
    const { t } = useTranslation();
    const transDqrScore = (dqr) => {
        if (dqr > 0 && dqr < 1.7) {
            return t('dqrLevel.high');
        } else if (dqr >= 1.7 && dqr < 3.0) {
            return t('dqrLevel.basic');
        } else if (dqr >= 3.0 && dqr < 5.0) {
            return t('dqrLevel.preliminary');
        } else {
            return "";
        }
    };
  return (
    <>
    <div className="col-12">
        <label className="font-semibold">{t('stage.dataQualtity')}</label>
   </div>
    <div className="col-12">
        <label className="form-label">{t('dataQualityScore')} &nbsp; {dqr}</label> 
    </div>
    <div className="col-12">
        <label className="form-label">{t('dataQualityLevel')} &nbsp; {transDqrScore(dqr)}  

        <Button tooltipOptions={{position: 'right'}} style={{alignItems:"flex-end",padding:'0px'}} severity="primary" 
            tooltip={t('dqrScoreTip')}
             text icon="pi pi-info-circle"/>
            </label> 
            
    </div>
   <div className="col-12">
       
        <label className="font-semibold">{t('productDataQuality')}
          
        </label> 
   </div>
    <div className="col-12">
        <label className="form-label">{t('rateOverallProductLabel')}</label> 
    </div>

    <div className="grid col-12 align-items-center">
            <div className="col-12 lg:col-2"> 
                <label htmlFor="productReliability" className="form-label">{t('productReliability')}</label> 
            </div>
            <div className="col-12 lg:col-6">
                <EnergyRating name={"productReliability"} control={control} tooltip={t('productReliability')} disabled={!isEditable}></EnergyRating>
            </div>
    </div>

    <div className="grid col-12 align-items-center">
            <div className="col-12 lg:col-2"> 
                <label htmlFor="productIntegrity" className="form-label">{t('productIntegrity')}</label> 
            </div>
            <div className="col-12 lg:col-6">
                <EnergyRating name={"productIntegrity"} control={control} tooltip={t('productIntegrity')} disabled={!isEditable}></EnergyRating>
            </div>
    </div>

    </>
  )
}

export default ProductDataQualityScore